import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const filtersButtonStyle = css`
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  height: 40px;
  min-height: 40px;
  justify-content: flex-start;
  margin: 0;
  outline: none;
  padding: ${theme.spacing(0, 2)};
  gap: ${theme.spacing(1)};
  transition: background-color 250ms ease-out;
  width: -webkit-fill-available;

  span {
    width: 100%;
  }

  > :first-letter {
    text-transform: uppercase;
  }

  :hover {
    background-color: ${theme.colors.neutral5};
  }
  :focus {
    background-color: ${theme.colors.neutral5};
    outline: none;
  }
`;

export const filtersContainerStyle = css`
  position: relative;
`;

export const filtersIndicatorStyle = css`
  position: absolute;
  left: ${theme.spacing(3)};
  top: ${theme.spacing(0.5)};
`;

export const filterSourceStyle = css`
  border-radius: ${theme.borderRadius.medium};
`;

export const radioFieldStyle = css`
  margin-bottom: ${theme.spacing(0)};
`;

export const selectedSourceStyle = css`
  position: relative;
`;

export const rightIconStyle = css`
  margin-left: auto;
`;
